export const recipeTypes = `
  data {
  id
    attributes {
      title
    }
  }
`;